
interface Teambuilding {
    id: string
    teambuildingId: string
    participants: number
}

const teambuildings:Array<Teambuilding> = []

const priceCalculator = async () => {
    document.addEventListener('onFormieInit', () => {
        setTimeout(() => {
            setListenersTeambuildings()
            setListenersParticipants()
            setListenersRepeatersDeleteButton()

            document.querySelector('.fui-repeater-add-btn')?.addEventListener('click', () => {
                setListenersTeambuildings()
                setListenersParticipants()
                setListenersRepeatersDeleteButton()
            })

            fetchPresetValues()
        }, 100)
    })
}

const fetchPresetValues = () => {
    const teambuildingSelector = document.querySelectorAll('.js-teambuilding-selector')

    teambuildingSelector.forEach(selector => {
        handleChangeTeambuildings(selector, false)
    })

    loadPricing()
}

const setListenersTeambuildings = () => {
    const teambuildingSelector = document.querySelectorAll('.js-teambuilding-selector')
    teambuildingSelector.forEach(selector => {
        if (!selector.hasAttribute('data-listener-added')) { // Check if the listener has been added before
            selector.addEventListener("change", evt => handleChangeTeambuildings(evt.currentTarget))
            selector.setAttribute('data-listener-added', 'true') // Add data attribute to tell the system the listener is attached.
        }
    })
}

const setListenersParticipants = () => {
    const participantsSelector = document.querySelectorAll('.js-participants-selector')
    participantsSelector.forEach(selector => {
        if (!selector.hasAttribute('data-listener-added')) { // Check if the listener has been added before
            selector.addEventListener("change", evt => handleChangeParticipants(evt.currentTarget))
            selector.setAttribute('data-listener-added', 'true') // Add data attribute to tell the system the listener is attached.
        }
    })
}

const setListenersRepeatersDeleteButton = () => {
    const buttons = document.querySelectorAll('.fui-repeater-remove-btn')

    if (!buttons) return

    buttons.forEach((selector: Element) => {
        if (!selector.hasAttribute('data-listener-added')) { // Check if the listener has been added before
            selector.addEventListener("click", evt => handleRemoveTeambuilding(evt.currentTarget as Element))
            selector.setAttribute('data-listener-added', 'true') // Add data attribute to tell the system the listener is attached.
        }
    })
}

const handleRemoveTeambuilding = (selector: Element|null) => {
    if (!selector) return

    const parent = selector.closest('.fui-repeater-row')
    const wrapper:Element|null = selector.closest('.fui-repeater-rows')
    const children = wrapper ? [...wrapper.children] : []

    if (!parent || children.length < 2) return

    const teambuildingId = parent.querySelector('.js-teambuilding-selector')?.id ?? null

    if (!teambuildingId) return null
    const teambuildingIndex = teambuildings.findIndex(teambuilding => teambuilding.id == teambuildingId);

    if (teambuildingIndex == -1) return null

    teambuildings.splice(teambuildingIndex, 1)
    loadPricing()
}

const handleChangeTeambuildings = (current, fetch = true) => {
    const parent = current?.closest('.fui-repeater-row')


    if (parent) {
        const data = {
            id: current.id,
            teambuildingId: current.value,
            participants: (document.querySelector('.js-participants-selector') as HTMLInputElement).value
        }

        provideTeambuildingData(data, fetch)
    }
}

const handleChangeParticipants = (current) => {
    const participantsValue = (current as HTMLInputElement).value

    teambuildings.forEach(item => {
        if (item.participants) {
            item.participants = parseInt(participantsValue)
        }
    })

    loadPricing()
}

const provideTeambuildingData = (data, fetch = true) => {
    if (data.teambuildingId && data.participants) {
        const existingTeambuilding = teambuildings.find(teambuilding => teambuilding.id == data.id)

        if (existingTeambuilding) {
            existingTeambuilding.teambuildingId = data.teambuildingId
            existingTeambuilding.participants = data.participants
        } else {
            teambuildings.push(data)
        }

        if (fetch) {
            loadPricing()
        }
    }
}

const loadPricing = () => {
    const priceCalculatorElement = document.getElementById('lod--price-calcultor')
    const formValueElement = document.querySelector('.js-indicative-price') as HTMLInputElement

    if(teambuildings.length == 0) {
        priceCalculatorElement?.classList.add('hidden')
        return
    }

    priceCalculatorElement?.classList.remove('hidden')

    if (!priceCalculatorElement) {
        console.error("Error: Element with ID 'lod--price-calculator' not found.");
        return;
    }

    const site = priceCalculatorElement?.getAttribute('data-site');
    const host = priceCalculatorElement?.getAttribute('data-url');
    const url = `${host}/lods/teammasters/lod--price-calculator?teambuildings=${encodeURIComponent(JSON.stringify(teambuildings))}&site=${site}`;

    fetch(url)
        .then(response => response.text())
        .then(html => {
            if (priceCalculatorElement) {  // Ensure it's still available before updating
                priceCalculatorElement.innerHTML = html;
            }
            const newPrice = priceCalculatorElement.querySelector('h3')?.getAttribute('data-price')
            if(formValueElement && newPrice) {
                formValueElement.value = newPrice
            }
        })
        .catch(error => console.error("Error fetching price calculator:", error));
}

// Execute async function
priceCalculator()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}
